import type { CreateCatalogRequest } from "@/lib/api/catalog";
import type { ItemCopyData } from "./CopyDetailsEditor";
import type { ReceiveIssueFieldValues } from "./ReceiveIssueFields";

type ItemDefaults = CreateCatalogRequest["itemDefaults"];

export function getReceiveIssueValidationError(
  fields: ReceiveIssueFieldValues,
  copies: number,
  defaults: ItemDefaults,
  copyData: ItemCopyData[],
  accessionNumberMode: "AUTO" | "MANUAL"
) {
  if (!fields.volumeNumber.trim()) return "Volume number is required.";
  if (copies < 1) return "At least one copy is required.";
  if (
    !defaults.itemTypeId ||
    !defaults.locationId ||
    !defaults.conditionCode ||
    !defaults.statusCode
  ) {
    return "Item type, location, condition, and status are required.";
  }
  if (copyData.length < copies || copyData.slice(0, copies).some((copy) => !copy.acquisitionMode)) {
    return "Acquisition mode is required for every copy.";
  }
  if (
    accessionNumberMode === "MANUAL" &&
    copyData.slice(0, copies).some((copy) => !copy.accessionNumber || copy.accessionNumber <= 0)
  ) {
    return "Accession number is required for every copy in manual mode.";
  }
  return null;
}
